<div class="workSpace">
    <!--nombre y filtro-->
    <div class="w3-container w3-containertemplate" style="height: 7%;">
        <!--Titulo de modulo y subtitulo-->
        <div class="w3-caja-menu padreizquierda w3-quarter">
            <div class="w3-row hijoizquierda centradoVertical">
                <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
                        'menu.'+dataService.moduleSelect | translate }} </b></span>
                <span class="w3-text-deep-orange">&bull;</span>
                <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{
                    'menu.'+dataService.subModuleSelect | translate }} </span>
            </div>
        </div>
        <!--Filtros-->
        <div class="w3-caja-menu padreizquierda w3-rest" style="height: 100%">
            <div class="w3-half w3-row centradoVertical">

            </div>
        </div>
    </div>
    <!--CONTENIDO TABLERO  -->
    <div class="w3-center tablero">
        @if (tabla) {
        <div class="contenido">
            <div class="w3-row">
                <div class="w3-row w3-half">
                    <div class="texto">
                        <div class="w3-right zonaTexto"><span
                                class="w3-right textoInputs">{{'cues.asignacion.cuestionario' | translate}}</span></div>
                    </div>
                    <div class="w3-rest">
                        <div class="zonaInput">
                            <select class="contentSelect" id="cuestionario" value="default"
                                (change)="filtroCuestionario()">
                                <option value="default">{{'cues.asignacion.seleccione' | translate}}</option>
                                @for (opt of cuestionarios; track opt.id) {
                                <option value="{{opt.id}}">{{opt.name}}</option>
                                }
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="conteTabla ">
                <div *ngIf="loadingAsignaciones" class="spinner-overlay">
                    <div class="spinner-css"></div> 
                </div>
                <div class="w3-row w3-right colorBotonDeNuevo" (click)="nuevaAsignacion('abrir')">
                    {{'cues.asignacion.asigNuevo' | translate}}
                    <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                </div>
                <div class="w3-row w3-scroll " style="max-height: 95%; width: 100%;">
                    <table mat-table [dataSource]="mostrarAsig">
                        @for (val of columnas; track val;) {
                        <ng-container matColumnDef="{{val}}">
                            <th mat-header-cell *matHeaderCellDef>
                                {{'cues.asignacion.titTab'+$index | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                @if ($index !=6 && $index != 1 && $index != 2) {
                                <span>{{element[val]}}</span> <!--codigo, fechaIn, fechaFin, responsable-->
                                }@if ($index == 1) {
                                <span>{{obtenerNombre(element[val])}}</span> <!--institucion-->
                                }@if ($index == 2) {
                                <span>{{element[val]}}</span> <!--cuesionario asignado-->
                                }@if ($index == 6) {
                                <span>{{'cues.asignacion.estatus'+element[val] | translate}}</span> <!--estatus-->
                                }@if ($index == 7) {
                                    <div [ngClass]="{'w3-disabled': element['estatus'] === 'open'}"
                                        [matMenuTriggerFor]="reporte" matTooltip="{{'acciones.exportar'|translate}}">
                                        <mat-icon class="iconoMen material-icons-outlined">attach_file</mat-icon>
                                    </div>
                                }
                                <mat-menu #reporte="matMenu">
                                    <button (click)="descargarReporte(element)" class="mat-menu-item" mat-menu-item
                                        class="w3-caja-menu">
                                        <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                                        <span>{{'acciones.exportar'|translate}}</span>
                                    </button>
                                </mat-menu>
                                @if ($index == 8) {
                                    <div>
                                        <mat-icon class="iconoMen material-icons-outlined"
                                            (click)="nuevaAsignacion('editar', element)"
                                            matTooltip="{{'acciones.editar'|translate}}">edit</mat-icon>
                                        <mat-icon class="iconoMen material-icons-outlined"
                                            (click)="nuevaAsignacion('eliminar', element)"
                                            matTooltip="{{'acciones.eliminar'|translate}}">delete</mat-icon>
                                        @if (permiteLinkAsignacion(element)) {
                                            <mat-icon class="iconoMen material-icons-outlined"
                                                (click)="copiarLinkAsignacion(element)"
                                                matTooltip="{{'cues.asignacion.copiarLink'|translate}}">link</mat-icon>
                                            <mat-icon class="iconoMen material-icons-outlined"
                                                (click)="registrarEncuestasEnviadas(element)"
                                                matTooltip="{{ tooltipEncuestasEnviadas(element) }}">mail</mat-icon>
                                        }
                                    </div>
                                }
                            </td>
                        </ng-container>
                        }
                        <tr mat-header-row *matHeaderRowDef="columnas; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: columnas;"></tr>
                    </table>
                </div>
            </div>
        </div>
        }@else {
            <div class="contenido">
                <div class="" style="display: flex; justify-content: center; align-items: center; height: 100%;">
                    <div class="w3-half ">
                        <div class="w3-row" [formGroup]="nuevaAsig">
                            <div class="w3-row headers w3-titulo-contenidomenuSC alinLeft">
                                <span class="w3-margin-left-contenido">{{'cues.asignacion.nueva' | translate}}</span>
                            </div>
                            <div class="w3-row" style="margin-top: 1vh; width: 100%;">
                                <div class="texto">
                                    <div class="w3-right zonaTexto"><span
                                            class="w3-right textoInputs">{{'cues.asignacion.cuestionario' |
                                            translate}}</span></div>
                                </div>
                                <div class="w3-rest">
                                    <div class="zonaInput" [ngClass]="{'w3-disabled': edicion}">
                                        <select class="contentSelect" formControlName="cuestionario" value="default">
                                            <option value="default">{{'cues.asignacion.seleccione' | translate}}</option>
                                            @for (c of cuestionarios; track c.id) {
                                                <option value="{{c.id}}">{{c.name}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="w3-row" style="margin-top: 1vh; width: 100%;">
                                <div class="texto">
                                    <div class="w3-right zonaTexto"><span
                                            class="w3-right textoInputs">{{'cues.asignacion.institucion' |
                                            translate}}</span></div>
                                </div>
                                <div class="w3-rest">
                                    <div class="zonaInput" [ngClass]="{'w3-disabled': edicion}">
                                        <select class="contentSelect" formControlName="institucion" value="default">
                                            <option value="default">{{'cues.asignacion.seleccione' | translate}}</option>
                                            @for (c of instituciones; track c.id) {
                                                <option value="{{c.id}}">{{c.name}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="w3-row headers w3-titulo-contenidomenuSC alinLeft">
                                <span class="w3-margin-left-contenido">{{'cues.asignacion.fechas' | translate}}</span>
                            </div>
                            <div class="w3-row" style="margin-top: 1vh; width: 100%;">
                                <div class="texto">
                                    <div class="w3-right zonaTexto"><span
                                            class="w3-right textoInputs">{{'cues.asignacion.titTab3' | translate}}</span>
                                    </div>
                                </div>
                                <div class="w3-rest">
                                    <div class="zonaInput" [ngClass]="{'w3-disabled': edicion}">
                                        <input type="date" class="contentDate" formControlName="fechaIni" value="2024-12-05"
                                            min='{{fechaAct}}' style="width: 100%;">
                                    </div>
                                </div>
                            </div>
                            <div class="w3-row" style="margin-top: 1vh; width: 100%;">
                                <div class="texto">
                                    <div class="w3-right zonaTexto"><span
                                            class="w3-right textoInputs">{{'cues.asignacion.titTab4' | translate}}</span>
                                    </div>
                                </div>
                                <div class="w3-rest">
                                    <div class="zonaInput">
                                        <input type="date" class="contentDate" formControlName="fechaFin"
                                            min="{{nuevaAsig.controls['fechaIni'].value}}" style="width: 100%;">
                                    </div>
                                </div>
                            </div>
                            <div class="w3-row headers w3-titulo-contenidomenuSC alinLeft">
                                <span class="w3-margin-left-contenido">{{'cues.asignacion.responsable' | translate}}</span>
                            </div>
                            <div class="w3-row" style="margin-top: 1vh; width: 100%;">
                                <div class="texto">
                                    <div class="w3-right zonaTexto"><span
                                            class="w3-right textoInputs">{{'cues.asignacion.nombre' | translate}}</span>
                                    </div>
                                </div>
                                <div class="w3-rest">
                                    <div class="zonaInput" [ngClass]="{'w3-disabled': edicion}">
                                        <input type="text" class="contentInput" formControlName="nombreRes"
                                            style="width: 100%;">
                                    </div>
                                </div>
                            </div>
                            <div class="w3-row" style="margin-top: 1vh; width: 100%;">
                                <div class="texto">
                                    <div class="w3-right zonaTexto"><span
                                            class="w3-right textoInputs">{{'cues.asignacion.cargo' | translate}}</span>
                                    </div>
                                </div>
                                <div class="w3-rest">
                                    <div class="zonaInput" [ngClass]="{'w3-disabled': edicion}">
                                        <input type="text" class="contentInput" formControlName="cargo"
                                            style="width: 100%;">
                                    </div>
                                </div>
                            </div>
                            <div class="w3-row" style="margin-top: 1vh; width: 100%;">
                                <div class="texto">
                                    <div class="w3-right zonaTexto"><span
                                            class="w3-right textoInputs">{{'cues.asignacion.correo' | translate}}</span>
                                    </div>
                                </div>
                                <div class="w3-rest">
                                    <div class="zonaInput" [ngClass]="{'w3-disabled': edicion}">
                                        <input type="email"
                                            [ngClass]="{'contentInput':!nuevaAsig.controls['correo'].hasError('email'),'contentInputError':nuevaAsig.controls['correo'].hasError('email')}"
                                            formControlName="correo" style="width: 100%;" matInput>
                                        @if (nuevaAsig.controls['correo'].hasError('email')) {
                                            <mat-error class="error-message">{{'cues.asignacion.campoInvalido' | translate}}</mat-error>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w3-row w3-right" style="margin-top: 1vh;">
                            <div class="botonesModales" [ngClass]="puedeGuardar()">
                                <button mat-flat-button color="success" style="height: 3vh;"
                                    (click)="nuevaAsignacion('guardar')">{{'cues.asignacion.guardar' | translate}}</button>
                            </div>
                            <div class="botonesModales">
                                <button mat-flat-button color="success2" style="height: 3vh;"
                                    (click)="nuevaAsignacion('cancel')">{{'cues.asignacion.cancelar' | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        }
    </div>
</div>